

export const DepartmentEnum = [
   {
    label: "Sales",
    value: "tCCr1sDtcMK4jCt4tFJT"
   },
   {
    label: "Management",
    value: "0eROMSzS9aukQikPbgSh"
   },
   {
    label: "Revenue",
    value: "PKTcjPR8VYXo5i9TqLnQ"
   }
]

export const sampleDepartmentEnum = [
  { label: "Sales", value: "Sales" },
  { label: "Management", value: "Management" },
  { label: "Revenue", value: "Revenue" },
];

export const salesDepartmentId = DepartmentEnum.find(
  (dept) => dept.label === "Sales"
)?.value;

export const managementDepartmentId = DepartmentEnum.find(
  (dept) => dept.label === "Management"
)?.value;

export const revenueDepartmentId = DepartmentEnum.find(
  (dept) => dept.label === "Revenue"
)?.value;

// Usage example:

export const salesDepartmentLabel = "Sales";

export const managementDepartmentLabel = "Management";

export const revenueDepartmentLabel = "Revenue";